import { ReactElement, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { ButtonIcon } from 'components/general';
import {
  DocumentState,
} from 'components/common/dataGrid/columnsFactory/types';
import { Color } from 'shared/utils/colors';
import { useDocumentationStore } from 'store/documentation';
import { StateToggleIcon } from 'components/common/StateToggleIcon';
import { DocumentationTranslationKeys } from 'intl/keys';
import { formatTranslation } from 'intl';

const DOCUMENT_STATE_TOOLTIP_KEY = {
  published: DocumentationTranslationKeys.statePublished,
  archived: DocumentationTranslationKeys.stateWithdrawn,
} as const;

const toggleOnIconSx = { color: Color.black };
const toggleOffIconSx = { color: Color.iconGray };

export function DocumentStateToggle(): ReactElement {
  const intl = useIntl();
  const value = useDocumentationStore.use.documentState();
  const setDocumentState = useDocumentationStore.use.setDocumentState();

  const handleChange = useCallback(
    (next: DocumentState) => {
      setDocumentState(next);
    },
    [setDocumentState]
  );

  const isOn = value === DocumentState.published;
  const nextValue = isOn
    ? DocumentState.archived
    : DocumentState.published;
  const tooltipTitle = formatTranslation(
    intl,
    DOCUMENT_STATE_TOOLTIP_KEY[isOn ? 'published' : 'archived']
  );

  const icon = (
    <StateToggleIcon
      isOn={isOn}
      onIconSx={toggleOnIconSx}
      offIconSx={toggleOffIconSx}
    />
  );

  return (
    <ButtonIcon onClick={() => handleChange(nextValue)} title={tooltipTitle}>
      {icon}
    </ButtonIcon>
  );
}